export default function selectJiraIsProjectLoading(
  state,
  { projectId, source }
) {
  const project =
    state.integrations.thirdPartyData[source].projects.byId[projectId]
  return project && project.loading
}
